<template>
  <div id="testimoni" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner testimoni-lists">
      <div class="carousel-item active item">
        <div class="row">
          <div class="col-md-5 col-7 mx-auto comment">
            <img
                src="images/quotation-left.svg"
                alt="person"
                class="quot-left"
            />
            Highly recommend TribeHired. It's a wonderful platform for career
            search. I was approached by Samuel, who understood exactly what i'm
            looking for and within a week i manage to land my dream job.
            <img
                src="images/quotation-right.svg"
                alt="person"
                class="quot-right"
            />
          </div>
        </div>
        <div
            class="
            d-flex
            justify-content-center
            mt-5
            flex-column
            align-items-center
            mb-5
          "
        >
          <img src="images/team.png" alt="person" class="rounded-circle" />
          <span class="name mt2">Arv** ******</span>
          <span class="other">Front End Developer</span>
        </div>
      </div>

      <div class="carousel-item item" v-for="testimony of testimonies">
        <div class="row">
          <div class="col-md-5 col-7 mx-auto comment">
            <img
                src="images/quotation-left.svg"
                alt="person"
                class="quot-left"
            />
            {{ testimony.comment }}
            <img
                src="images/quotation-right.svg"
                alt="person"
                class="quot-right"
            />
          </div>
        </div>
        <div
            class="
            d-flex
            justify-content-center
            mt-5
            flex-column
            align-items-center
            mb-5
          "
        >
          <img src="images/team.png" alt="person" class="rounded-circle"/>
          <span class="name mt2">{{ testimony.author }}</span>
          <span class="other">{{ testimony.position }}</span>
        </div>
      </div>
    </div>
    <a
        class="carousel-control-prev"
        href="#testimoni"
        role="button"
        data-slide="prev"
    >
      <span class="carousel-control-prev-icon custom-arrow" aria-hidden="true">
        <i class="fas fa-chevron-left"></i>
      </span>
    </a>
    <a
        class="carousel-control-next"
        href="#testimoni"
        role="button"
        data-slide="next"
    >
      <span class="carousel-control-next-icon custom-arrow" aria-hidden="true">
        <i class="fas fa-chevron-right"></i>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      testimonies: [
        {
          comment: 'Quality companies recommended by the recruiter. Matched my every requirement!',
          author: 'Chr** *** ***** ****',
          position: 'Business Operations',
        },
        {
          comment: '"Our team will support you so you\'re not alone" - This is the message impressed me the most.\n',
          author: 'Eve*** *** *******',
          position: 'Software Developer',
        },
        {
          comment: 'TribeHired is really one of the more professional recruiters out there. They introduced good clients and follow up very well and help you get as much information as possible.',
          author: 'Lan* ****',
          position: 'Software Developer',
        },
        {
          comment: 'Ran by an approachable, professional, and driven team. Great at connecting and helping tech job seekers find jobs in the industry.',
          author: 'Lee ****** ***',
          position: 'Software developer',
        },
        {
          comment: 'TribeHired is the best platform that serves as a perfect mediator between developers and the employees. I have been working with them for some time now, I like many things about TribeHired like: \n',
          author: 'Bas****** ****',
          position: 'Software Developer',
        },
        {
          comment: 'Great platform if you looking out for tech based job. Professional personnel who provide quick response and helps whenever needed.',
          author: 'Win*** ***',
          position: 'Software Developer',
        },
        {
          comment: 'Love this platform, very professional and helpful, and quick to connect to the right people.',
          author: 'Lie* **** ***',
          position: 'Software Developer',
        },
        {
          comment: 'I got in touch with Devan, who landed me an opportunity with an IT software house. Devan was always responsive, straight-to-the point, and very helpful. Thanks Devan and TribeHired!',
          author: 'Asy*** *******',
          position: 'Software Developer',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@mixin font-style {
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
}

#testimoni {
  .testimoni-lists {
    .item {
      color: #fff;
      @include font-style;
      line-height: 28px;

      // .comment {
      position: relative;

      .quot-left,
      .quot-right {
        position: absolute;
      }

      .quot-left {
        top: 0;
        left: -10%;
        @media (max-width: 768px) {
          top: -10px;
          width: 30px;
          height: 55px;
        }
      }

      .quot-right {
        bottom: 0;
        right: -10%;

        @media (max-width: 768px) {
          bottom: -10px;
          width: 30px;
          height: 55px;
        }
      }

      // }

      .name {
        @include font-style;
        line-height: 22px;
        color: #fff;
      }

      .other {
        font-size: 14px;
        font-family: "Open Sans", sans-serif;
        letter-spacing: 0;
        line-height: 22px;
        color: #fff;
      }
    }
  }

  a {
    opacity: 1;
  }

  .custom-arrow {
    background: white;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .fas {
      color: #5abede;
      font-size: 16px;
    }
  }
}
</style>
